import { Button, Link } from '@chakra-ui/react';

interface ContentSkipProps {
  skipToContentId?: string;
  label?: string;
}
export const ContentSkip = (props: ContentSkipProps) => {
  const { skipToContentId = '#main', label = 'Skip to content' } = props;

  return (
    <Button
      as={Link}
      href={skipToContentId}
      colorScheme="gray"
      variant="solid"
      position="fixed"
      zIndex="popover"
      left={2}
      top={2}
      transform="translate(0, -100px)"
      _focusVisible={{
        transform: 'translate(0, 0)'
      }}
      _dark={{
        bgColor: 'gray.700'
      }}
    >
      {label}
    </Button>
  );
};
